module.exports = __webpack_public_path__ + "img/bell-concierge.7fe70ad1.svg";